import * as zod from 'zod';

export default zod.object({
  message: zod.string(),
  isRecoverable: zod.boolean(),
});
